"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrder = void 0;
var SortOrder;
(function (SortOrder) {
    SortOrder["DESC"] = "descending";
    SortOrder["ASC"] = "ascending";
    SortOrder["NONE"] = "none";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
//# sourceMappingURL=constants.js.map